import { useState, createContext, useEffect, useRef, useContext } from "react"
import { UserDetails } from "../../Components/UsersDetails";
import { useNavigate } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import { HideLoder, LogInUserID, LogInSchoolID, ShowLoder, YYYYMMDD, isValidEmail, typewatch, getUrlParameter, handleCustomSubmit, getAllBuildings, YYYYMMDD_HHMM, resetFormValidationErrors, parseDateOnly, scrollToFirstInvalidField } from "../../JS/Common";
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from "../../JS/Connector";
import AlertsComp from "../../Components/AlertsComp";
import { CheckValidation } from "../../Components/Validations";
import CustomFields from "../CustomField/CustomFields";
import { UserContext } from "../../App";
import CustomReactDatePicker from "../../Components/CustomReactDatePicker";
import { useSelector } from "react-redux";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";

export const userdetailscontent = createContext();
export function AddUpdate() {
    const { is_enterprise, show_policy_no_field, show_grade_field, primary_text, dcc_module_text } = useConfig();
    const { manager } = useConfig();
    const [utils, setUtils] = useState({
        Alerts: "",
        Loading: false,
        innerload: false
    })
    const suggestionBoxRef = useRef(null);
    const [UpdateFlag, setUpdateFlag] = useState(1);
    const [SuggestionBoxArray, setSuggestionBoxArray] = useState([]);
    const navigate = useNavigate();
    const [Alerts, setAlerts] = useState("");
    const [SearchString, setSearchString] = useState('');
    const [FormShowHide, setFormShowHide] = useState({
        AssignDeviceDiv: "",
        UserDiv: "d-none",
        UpdateDiv: "d-none",
        SuggestionBoxShow: "d-none",
        UserDetailDiv: "d-none",
        loanerdisable: false
    });
    const [ShowSuggestionDevice, setShowSuggestionDevice] = useState('d-none');
    const [allData, setAllData] = useState({
        SerialNumber: "",
        DeviceModel: "",
        DeviceManufacturer: "",
        DeviceModelId: "",
        DeviceManufacturerId: "",
        Devicetype: 1,
        DeviceMPN: "",
        AssetTag: "",
        RepairCap: "",
        DeviceOS: "",
        PurchaseDate: "",
        ExpectedRetirement: "",
        ManufacturerWarrentyUntil: "",
        ManufacturerADPUntil: "",
        ThirdPartyWarrantyUntil: "",
        ThirdPartyADPUntil: "",
        ParentEmail: "",
        StudentIDD: null,
        ParentName: "",
        FirstName: "",
        MiddleName: '',
        LastName: "",
        Grade: "",
        Department: "",
        IsStudent: "",
        gradeerror: "",
        Building: "",
        StudentNumber: "",
        ParentPhoneNumber: "",
        ParentCheck: 0,
        emailError: "",
        CheckLoanerDevice: 0,
        CheckAssignDevice: 0,
        Buildingname: "",
        addupdateNotes: '',
        SelectedRooms: '',
        departmenterror: "",
        UserEmail: "",
        adpcoverageuntil: "",
        policyNumber: ""
    });
    const [ExistingNew, setExistingNew] = useState(0)
    const [hideshowflag, sethideshowflag] = useState(0)
    const [Exisitingerror, setExisitingerror] = useState("")
    const [loading, setLoading] = useState(false);
    const [Buildings, setBuildings] = useState([]);
    const [showbuildingdiv, setshowbuildingdiv] = useState("d-none");
    const inputRef = useRef(null);
    const StateData = useSelector((state) => state.authData);
    const adminschoolid = StateData?.AdminSchoolId;
    const { UserData } = useContext(UserContext);
    const [NewUserFlag, setNewUserFlag] = useState('')
    const [customFields, setCustomFields] = useState([])
    const [OriginalCustomFields, setOriginalCustomFields] = useState([])
    const [adminCustomFields, setAdminCustomFields] = useState([])
    const [OriginalAdminCustomFields, setAdminOriginalCustomFields] = useState([])
    const [errors, setErrors] = useState({});
    const [RoomArray, setRoomArray] = useState([])
    const [radiorequired, setradiorequired] = useState('')
    const [highlightIndex, setHighlightIndex] = useState(-1);
    const [manufacturerData, setManufacturerData] = useState([]);
    const [modelData, setmodelData] = useState([]);
    const [manufacturerSuggestions, setManufacturerSuggestions] = useState([]);
    const [showManufSuggestions, setShowManufSuggestions] = useState(false);
    const [showModelSuggestions, setShowModelSuggestions] = useState(false);
    const manufBoxRef = useRef(null);
    const modelBoxRef = useRef(null);
    const deviceManufacturerIdRef = useRef(allData.DeviceManufacturerId);
    const { copyaccesstype, role, copyrole } = UserData;
    const effectiveRole = copyrole || role || null;
    const AdminMenuAccessFlag = hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS);

    async function fetchFun() {
        const manufacturerList = await getDeviceManufacturer();
        GetDeviceById(manufacturerList);
    }

    useEffect(() => {
        deviceManufacturerIdRef.current = allData.DeviceManufacturerId;
    }, [allData.DeviceManufacturerId]);

    useEffect(() => {
        var schoolid = adminschoolid ? adminschoolid : LogInSchoolID
        getAllBuildings(setBuildings, schoolid);
        GetCustomFieldsData();
        fetchFun();
        const handleClickOutside = (event) => {
            if (suggestionBoxRef.current && !suggestionBoxRef.current.contains(event.target)) {
                setShowSuggestionDevice('d-none')
            }
            if (manufBoxRef.current && !manufBoxRef.current.contains(event.target)) {
                setShowManufSuggestions(false);
            }
            if (modelBoxRef.current && !modelBoxRef.current.contains(event.target)) {
                setShowModelSuggestions(false);
            }
        };
        const handleWindowClick = (event) => {
            handleClickOutside(event);
        };
        window.addEventListener('click', handleWindowClick);
        return () => {
            window.removeEventListener('click', handleWindowClick);
        };
    }, []);
    useEffect(() => {
        if (allData.Building === "0") {
            inputRef.current && inputRef.current.focus();
        }
    }, [allData.Building]);

    const getDeviceManufacturer = async () => {
        let responseRs = [];
        await ApiGetCall(`/device-manufacturers`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                responseRs = JSON.parse(result);
                setManufacturerData([
                    ...(responseRs || []),
                    { name: 'Other', id: 'other' }
                ]);
            }
        })
        return responseRs;
    }
    const getModelsFromManufacturer = async (id, showLoader = true, searchString) => {
        if (showLoader) { setLoading(true); }
        let responseRs = [];
        await ApiGetCall(`/device-models?uuid=${id || null}&search=${searchString}`).then((result) => {
            setLoading(false)
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    setmodelData([
                        ...(responseRs || []),
                        { name: 'Other', id: 'other' }
                    ])
                } else {
                    setmodelData([
                        { name: 'Other', id: 'other' }
                    ]);
                }
            }
        })
        return responseRs
    }

    // Case 1: manufacturer search box - client side filter over the already loaded manufacturerData, "Other" always pinned
    const handleManufacturerSearch = (text) => {
        const trimmed = text?.trim() || '';
        const matchedManufacturer = manufacturerData.find(
            item => item.id !== 'other' && item.name?.trim().toLowerCase() === trimmed.toLowerCase()
        );

        if (matchedManufacturer) {
            setAllData(prev => ({
                ...prev,
                DeviceManufacturer: matchedManufacturer.name,
                DeviceManufacturerId: matchedManufacturer.id,
                DeviceModelId: '',
                DeviceModel: ''
            }));
            setManufacturerSuggestions([matchedManufacturer, { name: 'Other', id: 'other' }]);
            setShowManufSuggestions(false);
            getModelsFromManufacturer(matchedManufacturer.id, false, null);
            return;
        }

        setAllData(prev => ({ ...prev, DeviceManufacturer: trimmed, DeviceManufacturerId: '', DeviceModelId: '' }));
        setShowManufSuggestions(true);
        setManufacturerSuggestions(
            trimmed
                ? manufacturerData.filter(m => m.id === 'other' || m.name?.toLowerCase().includes(trimmed.toLowerCase()))
                : manufacturerData
        );
        if (trimmed == '') {
            setmodelData([
                { name: 'Other', id: 'other' }
            ]);
        }
    };

    // Case 1/4: manufacturer selected from dropdown (or "Other")
    const handleManufacturerSelect = (item) => {
        if (item.id === 'other') {
            // Case 4: typed text stays as-is, moves into the "Enter Manufacturer Name" box
            setAllData(prev => ({
                ...prev,
                DeviceManufacturerId: 'other',
                DeviceManufacturer: '',
                DeviceModelId: '',
                DeviceModel: ''
            }));
        } else {
            setAllData(prev => ({
                ...prev,
                DeviceManufacturerId: item.id,
                DeviceManufacturer: item.name,
                DeviceModelId: '',
                DeviceModel: ''
            }));
            getModelsFromManufacturer(item.id, false, null);
        }
        setShowManufSuggestions(false);
    };

    // Case 1/2: model search box - scoped to manufacturer if one is selected, otherwise a global backend search
    const handleModelSearch = (text) => {
        setAllData(prev => ({ ...prev, DeviceModel: text, DeviceModelId: '' }));
        setShowModelSuggestions(true);
        typewatch(() => {
            const manufId = deviceManufacturerIdRef.current && deviceManufacturerIdRef.current !== 'other'
                ? deviceManufacturerIdRef.current
                : null;
            getModelsFromManufacturer(manufId, false, text?.trim() || null);
        }, 400);
    };

    // Case 2/3: model selected from dropdown (or "Other")
    const handleModelSelect = (item) => {
        if (item.id === 'other') {
            // Case 3: typed text stays as-is, moves into the "Enter Model" box, manufacturer untouched
            setAllData(prev => ({ ...prev, DeviceModelId: 'other', DeviceModel: '' }));
        } else if (item.manufacture_id) {
            // Case 2: global search result - auto select the matching manufacturer
            const matchedManufacturer = manufacturerData.find(m => m.id == item.manufacture_id);
            setAllData(prev => ({
                ...prev,
                DeviceModelId: item.id,
                DeviceModel: item.model_name,
                ...(matchedManufacturer ? {
                    DeviceManufacturerId: matchedManufacturer.id,
                    DeviceManufacturer: matchedManufacturer.name
                } : {})
            }));
            if (matchedManufacturer) {
                getModelsFromManufacturer(matchedManufacturer.id, false, null);
            }
        } else {
            setAllData(prev => ({ ...prev, DeviceModelId: item.id, DeviceModel: item.name }));
        }
        setShowModelSuggestions(false);
    };

    async function GetCustomFieldsData(id) {
        setLoading(true);
        var Deviceid = getUrlParameter("id")
        Deviceid = Deviceid ? Deviceid : null
        var schoolIdParam = adminschoolid ? adminschoolid : LogInSchoolID;
        await ApiGetCall(`/custom-fields/parent-values-by-id?schoolId=${schoolIdParam}&parentObjectType=1&parentObjectId=${Deviceid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);

                const filteredCustomFields = (AdminMenuAccessFlag || copyaccesstype != null) ? responseRs?.school_custom_fields : responseRs?.school_custom_fields?.filter(field => field.is_system_locked !== 2) || [];
                setCustomFields(filteredCustomFields)
                setOriginalCustomFields(filteredCustomFields)

                setAdminCustomFields([])
                setAdminOriginalCustomFields([])
            }
        });
    }
    async function GetDeviceById(manufacturerList = []) {
        var Deviceid = getUrlParameter("id");
        if (Deviceid != false) {
            setUpdateFlag(2);
            await ApiGetCall(`/inventory/by-id?uuid=${Deviceid}`).then(async (result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    var sugData = responseRs.msg;
                    var existingnew = sugData.student != null ? 1 : 0;
                    setNewUserFlag(sugData.student != null ? sugData.student.id : null)
                    setExistingNew(existingnew)
                    var isstudent = 0;
                    if (sugData.student != null) {
                        if (sugData.student?.grade != "" || sugData.student?.grade != null) {
                            isstudent = 1;
                        }
                    }

                    const deviceManufacturerId = sugData?.device_manufacturer_id;
                    const deviceModelId = sugData?.device_model_id;
                    const manufacturerExists = deviceManufacturerId != null
                        && manufacturerList?.some(m => m?.id == deviceManufacturerId);

                    let resolvedManufacturerId;
                    let resolvedModelId;

                    if (deviceManufacturerId != null) {
                        if (manufacturerExists) {
                            // Case 5 (match): select the manufacturer and resolve the model against its own model list
                            resolvedManufacturerId = deviceManufacturerId;
                            const modelsFromManu = await getModelsFromManufacturer(deviceManufacturerId, false, null);
                            const modelExists = deviceModelId != null && modelsFromManu?.some(m => m?.id == deviceModelId);
                            resolvedModelId = deviceModelId != null ? (modelExists ? deviceModelId : 'other') : deviceModelId;
                        } else {
                            // Case 5 (no match): manufacturer -> other, model goes straight to the "other" input too
                            resolvedManufacturerId = 'other';
                            resolvedModelId = 'other';
                            setLoading(false);
                        }
                    } else {
                        // Case 6: manufacturer id is null - leave it open for search, resolve model against the global model list
                        resolvedManufacturerId = null;
                        const modelsFromManu = await getModelsFromManufacturer(null, false, null);
                        const modelExists = deviceModelId != null && modelsFromManu?.some(m => m?.id == deviceModelId);
                        resolvedModelId = deviceModelId != null ? (modelExists ? deviceModelId : 'other') : deviceModelId;
                    }

                    setAllData({
                        ...allData,
                        SerialNumber: sugData.serial_number,
                        DeviceModel: sugData.device_model,
                        DeviceModelId: resolvedModelId,
                        DeviceManufacturer: sugData.device_manufacturer,
                        DeviceManufacturerId: resolvedManufacturerId,
                        DeviceMPN: sugData.device_mpn,
                        AssetTag: sugData.asset_tag,
                        RepairCap: sugData.repair_cap,
                        DeviceOS: sugData.device_os,
                        PurchaseDate: sugData.purchase_date && (sugData.purchase_date),
                        ExpectedRetirement: sugData.expected_retirement && (sugData.expected_retirement),
                        ManufacturerWarrentyUntil: sugData.manufacturer_warranty_until && (sugData.manufacturer_warranty_until),
                        ManufacturerADPUntil: sugData.manufacturer_adp_until && (sugData.manufacturer_adp_until),
                        ThirdPartyWarrantyUntil: sugData.third_party_extended_warranty_until && (sugData.third_party_extended_warranty_until),
                        ThirdPartyADPUntil: sugData.third_party_adp_until && (sugData.third_party_adp_until),
                        ParentEmail: sugData.student && (sugData.student.parent_guardian_email),
                        StudentIDD: sugData.student && (sugData.student.id),
                        ParentName: sugData.student && (sugData.student.parent_guardian_name),
                        FirstName: sugData.student && (sugData.student.device_user_first_name),
                        MiddleName: sugData.student && (sugData.student.device_user_middle_name),
                        LastName: sugData.student && (sugData.student.device_user_last_name),
                        Grade: sugData.student && (sugData.student.grade),
                        Department: sugData.student && (sugData.student.department),
                        IsStudent: sugData.student ? (sugData.student.is_student) : 0,
                        Building: sugData.building_id,
                        StudentNumber: sugData.student && (sugData.student.student_num),
                        ParentPhoneNumber: sugData.student && (sugData.student.parent_phone_number),
                        CheckLoanerDevice: sugData.loaner_device,
                        ParentCheck: sugData.student && (sugData.student.parental_coverage),
                        CheckAssignDevice: sugData.student != null ? 1 : 0,
                        emailError: "",
                        addupdateNotes: sugData.notes,
                        SelectedRooms: sugData?.room_details?.id,
                        UserEmail: sugData.student && (sugData.student.student_email),
                        adpcoverageuntil: sugData.k12_adp_coverage_date && (sugData.k12_adp_coverage_date),
                        policyNumber: sugData?.policy_number || ""
                    })

                    if (sugData.loaner_device == "1") {
                        setFormShowHide({ ...FormShowHide, AssignDeviceDiv: "d-none", UserDiv: "d-none", SuggestionBoxShow: "d-none", UpdateDiv: "d-none", UserDetailDiv: "d-none" })
                    } else {
                        if (sugData.student != null) {
                            setFormShowHide({ ...FormShowHide, UserDiv: "", UserDetailDiv: "d-none", SuggestionBoxShow: "", AssignDeviceDiv: "", UpdateDiv: "", loanerdisable: true });
                        } else {
                            setFormShowHide({ ...FormShowHide, UserDiv: "d-none", UserDetailDiv: "d-none", SuggestionBoxShow: "d-none", AssignDeviceDiv: "", UpdateDiv: "d-none", });

                        }
                    }
                    if (sugData?.building_id != null) {
                        EditBuildingGetData(sugData?.building_id)
                    }
                }
            });
        } else {
            setUpdateFlag(1);
            setLoading(false);
        }
    }
    async function AddUpdateDevice(flag) {
        let errors = {};
        var UserFlag = "no";
        var LoanerFlag = "no";
        var existnewflag = "new";
        var deviceid = 0;
        if (getUrlParameter("id") != false) {
            deviceid = getUrlParameter("id");
        }
        var isFormValid = CheckValidation({ formID: 'AddInventoryForm' });
        if (allData.UserEmail == null) {
            allData.UserEmail = "";
        }
        if (allData.UserEmail !== "") {
            if (!isValidEmail(allData.UserEmail)) {
                errors.userEmailError = "*Invalid Email";
                isFormValid = false;
            } else {
                errors.userEmailError = "";
            }
        }
        if (allData.CheckAssignDevice == 0 && isFormValid == true) {
            isFormValid = true;
        }
        if (allData.CheckLoanerDevice == 1) {
            LoanerFlag = "yes";
        }
        if (allData.CheckAssignDevice == 1) {
            if (allData.StudentIDD == null && allData.StudentNumber != '') {
                UserFlag = 'yes'
            } else if (NewUserFlag == allData.StudentIDD) {
                UserFlag = "onlydevicechange";
            } else {
                UserFlag = "yes";
            }
        }
        if (ExistingNew == 1 && hideshowflag != 1) {
            existnewflag = "existing";
            if (allData.FirstName == "") {
                setExisitingerror("First you need to add user.")
                isFormValid = false;
            }
        }
        if (allData.ParentEmail == null) {
            allData.ParentEmail = "";
        }
        if (allData.ParentEmail !== "") {
            if (!isValidEmail(allData.ParentEmail)) {
                errors.emailError = "*Invalid Email";
                isFormValid = false;
            } else {
                errors.emailError = "";
            }
        }
        setAllData({ ...allData, ...errors });
        let customFieldValues = handleCustomSubmit(customFields, OriginalCustomFields, flag);
        if (customFields.length > 0) {
            customFields.map((item, index) => {
                let tempErrors = {};

                customFields.forEach((item, index) => {
                    if ((item.value_type == 6 || item.value_type == 7) && item.is_required == 1) {
                        if (item.value_type == 6 ? item.value == null : item.value.length == 0) {
                            tempErrors[item.id] = "*required";
                            isFormValid = false;
                        }
                    }
                });

                setradiorequired(tempErrors);
            })
        }
        // let adminCustomFieldValues = handleCustomSubmit(adminCustomFields, OriginalAdminCustomFields, flag);
        // if (adminCustomFields.length > 0) {
        //     adminCustomFields.map((item, index) => {
        //         if (item.value_type == 6 && item.is_required == 1) {
        //             if (item.value == null) {
        //                 setradiorequired("*required");
        //                 isFormValid = false;
        //             } else {
        //                 setradiorequired("");

        //             }
        //         }
        //         if (item.value_type == 7 && item.is_required == 1) {
        //             if (item.value.length == 0) {
        //                 setcheckboxrequired("*required");
        //                 isFormValid = false;
        //             } else {
        //                 setcheckboxrequired("");

        //             }
        //         }
        //     })
        // }
        if (!isFormValid) {
            scrollToFirstInvalidField('AddInventoryForm');
            return;
        };
        customFieldValues = [...customFieldValues]
        setLoading(true);
        var raw = JSON.stringify({
            uuid: deviceid,
            schoolId: !copyaccesstype && AdminMenuAccessFlag ? adminschoolid : LogInSchoolID,
            userId: LogInUserID,
            manufacturerWarrantyUntil: allData.ManufacturerWarrentyUntil,
            manufacturerAdpUntil: allData.ManufacturerADPUntil,
            thirdPartyExtendedWarrantyUntil: allData.ThirdPartyWarrantyUntil,
            thirdPartyAdpUntil: allData.ThirdPartyADPUntil,
            expectedRetirement: allData.ExpectedRetirement,
            purchaseDate: allData.PurchaseDate,
            deviceManufacturer: allData.DeviceManufacturer,
            deviceManufacturerId: allData.DeviceManufacturerId === 'other' || !allData.DeviceManufacturerId ? 0 : allData.DeviceManufacturerId,
            deviceUserFirstName: allData.FirstName,
            deviceUserMiddleName: allData.MiddleName,
            deviceModel: allData.DeviceModel,
            deviceModelId: allData.DeviceModelId === 'other' || !allData.DeviceModelId ? 0 : allData.DeviceModelId,
            serialNumber: allData.SerialNumber,
            buildingId: allData.Building == '' || allData.Building == null ? null : allData.Building,
            parentName: allData.ParentName,
            parentPhoneNumber: allData.ParentPhoneNumber,
            deviceOs: allData.DeviceOS,
            deviceUserLastName: allData.LastName,
            grade: allData.Grade,
            deviceMpn: allData.DeviceMPN,
            assetTag: allData.AssetTag,
            parentEmail: allData.ParentEmail,
            repairCap: allData.RepairCap,
            loanerDevice: allData.CheckLoanerDevice,
            parentalCoverage: allData.ParentCheck,
            userFlag: UserFlag,
            loanerFlag: LoanerFlag,
            existingNewFlag: existnewflag,
            studentId: allData.StudentIDD,
            studentNumber: allData.StudentNumber,
            addUpdateFlag: UpdateFlag,
            buildingName: allData.Buildingname,
            notes: allData.addupdateNotes,
            parentObjectType: 1,
            parentObjectID: 0,
            customFieldValues: customFieldValues,
            department: allData.Department,
            roomId: allData.SelectedRooms ? allData.SelectedRooms : null,
            IsStudent: allData.IsStudent,
            studentEmail: allData.UserEmail,
            adpCoverageUntil: allData.adpcoverageuntil,
            policyNumber: allData.policyNumber,
        });
        await ApiPostCall("/inventory/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    if (UpdateFlag == 1) {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"Device Added Successfully."} />);
                    } else {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"Device Updated Successfully."} />);
                    }
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        if (AdminMenuAccessFlag) {
                            if (copyaccesstype) {
                                if (LoanerFlag == "yes") {
                                    navigate('/manage-device', { state: { LoanerFlag } });
                                } else {
                                    navigate('/manage-device', { state: null });
                                }
                            } else {
                                navigate('/school-tickets');
                            }
                        } else {
                            if (LoanerFlag == "yes") {
                                navigate('/manage-device', { state: { LoanerFlag } });
                            } else {
                                navigate('/manage-device', { state: null });
                            }
                        }
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    function handelLonerChange(flag) {
        if (flag == "yes") {
            setAllData({ ...allData, CheckLoanerDevice: 1, CheckAssignDevice: 0 });
            setExistingNew(0);
            setFormShowHide({ ...FormShowHide, AssignDeviceDiv: "d-none", UserDiv: "d-none", SuggestionBoxShow: "d-none", UpdateDiv: "d-none", UserDetailDiv: "d-none" })
        } else {
            setFormShowHide({ ...FormShowHide, AssignDeviceDiv: "", UserDiv: "d-none", UserDetailDiv: "d-none" })
            setAllData({ ...allData, CheckLoanerDevice: 0, CheckAssignDevice: 0 });
            setExistingNew(0);
        }
    }
    function handelUserChange(flag) {
        if (flag == "yes") {
            setFormShowHide({ ...FormShowHide, UserDiv: "", UserDetailDiv: "", SuggestionBoxShow: "d-none" });
            resetUserFields(1);
            setExistingNew(0);
            setExisitingerror('');
            sethideshowflag(0);
        } else {
            setFormShowHide({ ...FormShowHide, UserDiv: "d-none", UserDetailDiv: "d-none", SuggestionBoxShow: "", UpdateDiv: "d-none" });
            resetUserFields(0);
            setExistingNew(1);
            setExisitingerror('');
            sethideshowflag(1);
        }
        resetFormValidationErrors("AddInventoryForm");
    }
    function handleExistingnewuser(flag) {
        if (flag == "existing") {
            if (UpdateFlag == 1) {
                setExistingNew(1)
                setFormShowHide({ ...FormShowHide, SuggestionBoxShow: "", UserDetailDiv: "d-none", UpdateDiv: "d-none" });
            } else {
                if (allData.FirstName != null && allData.FirstName != "") {
                    GetDeviceById(manufacturerData);
                }
                setFormShowHide({ ...FormShowHide, SuggestionBoxShow: "", UserDetailDiv: "d-none", UpdateDiv: "" });
                setAllData({ ...allData, UserEmail: "", FirstName: "", MiddleName: "", LastName: "", StudentNumber: "", StudentIDD: null, ParentEmail: "", ParentName: "", Grade: "", IsStudent: 0, Department: "", ParentPhoneNumber: "", ParentCheck: 0 });
                setExistingNew(1)
            }
        } else {
            setExistingNew(0)
            setAllData({ ...allData, UserEmail: "", FirstName: "", MiddleName: "", LastName: "", StudentNumber: "", StudentIDD: null, ParentEmail: "", ParentName: "", Grade: "", IsStudent: 0, Department: "", ParentPhoneNumber: "", ParentCheck: 0 });
            setFormShowHide({ ...FormShowHide, SuggestionBoxShow: "d-none", UserDetailDiv: "", UpdateDiv: "d-none" });
        }
        resetFormValidationErrors("AddInventoryForm");
    }
    async function SearchUsers(SearchString) {
        setSuggestionBoxArray([]);
        if (SearchString?.trim() == "") {
            SearchString = null;
            setShowSuggestionDevice('d-none')
        } else {
            setShowSuggestionDevice('')
            SearchString = SearchString?.trim();
        }
        typewatch(async function () {
            const schoolid = !copyaccesstype && AdminMenuAccessFlag ? adminschoolid : LogInSchoolID;
            setUtils({ ...utils, innerload: true })
            await ApiGetCall(`/utilizers/search?schoolId=${schoolid}&search=${SearchString}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    var sugData = responseRs;
                    var vArray = [];
                    if (sugData.length != 0) {
                        setShowSuggestionDevice("");
                        vArray = sugData?.map((item, i) => (
                            <div className="row brdr-Btm font-14" key={i} style={{ padding: "8px 15px" }} onClick={(e) => ShowUserDetails(item.id)} utilizerid={item.id}>
                                <div className='col-9'>User : <b>{item.device_user_first_name} {item.device_user_middle_name == null ? '' : item.device_user_middle_name} {item.device_user_last_name}</b></div>
                                <div className="col-3 text-end">{item.student_num}</div>
                                <div className="col-12">{item.parent_guardian_email}</div>
                            </div>
                        ))
                    } else {
                        if (!utils.innerload) {
                            var html = <div className="brdr-Btm font-14 text-center" style={{ padding: "8px 15px" }}>
                                No Record Found
                            </div>
                            vArray.push(html)
                        }
                    }
                    setUtils({ ...utils, innerload: false })
                    setSuggestionBoxArray(vArray);
                    setLoading(false);
                }
            });
        }, 500);

    }
    async function ShowUserDetails(utilizerid) {
        // var utilizerid = e.currentTarget.attributes[1].value;
        GetUtilizerDataById(utilizerid);
    }
    async function GetUtilizerDataById(utilizerid) {
        await ApiGetCall(`/utilizers/by-id?uuid=${utilizerid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                var sugData = responseRs.msg;
                if (responseRs.status == "success") {
                    setFormShowHide({ ...FormShowHide, UpdateDiv: "" });
                    setShowSuggestionDevice("d-none");
                    setAllData({
                        ...allData,
                        FirstName: sugData.device_user_first_name,
                        MiddleName: sugData.device_user_middle_name,
                        LastName: sugData.device_user_last_name,
                        StudentNumber: sugData.student_num,
                        ParentName: sugData.parent_guardian_name,
                        ParentEmail: sugData.parent_guardian_email,
                        ParentPhoneNumber: sugData.parent_phone_number,
                        ParentCheck: sugData.parental_coverage,
                        StudentIDD: sugData.id,
                        Grade: sugData.grade,
                        Department: sugData.department,
                        IsStudent: sugData.is_student,
                        UserEmail: sugData.student_email,
                    })
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }

    const handleFieldChange = (index, newValue) => {
        const newArray = [...customFields];
        newArray[index] = { ...newArray[index], value: newValue };
        setCustomFields(newArray);
    };
    const handleAdminFieldChange = (index, newValue) => {
        const newArray = [...adminCustomFields];
        newArray[index] = { ...newArray[index], value: newValue };
        setAdminCustomFields(newArray);
    };

    async function EditBuildingGetData(id) {
        await ApiGetCallAuthKey(`/buildings?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.msg?.room.length != 0) {
                    setRoomArray(responseRs?.msg?.room)
                } else {
                    setRoomArray([])
                }
            }
        });
    }

    const scrollToItem = (reference, index) => {
        if (!reference.current) return;
        const container = reference.current;
        const item = container.children[index];
        if (item) {
            item.scrollIntoView({
                block: "nearest",
                behavior: "smooth",
            });
        }
    };

    const handleUserSelect = (e) => {
        if (e.key == "ArrowDown") {
            e.preventDefault();
            setHighlightIndex((prev) => {
                const nextItem = prev < SuggestionBoxArray.length - 1 ? prev + 1 : 0;
                scrollToItem(suggestionBoxRef, nextItem);
                return nextItem;
            });
        } else if (e.key == "ArrowUp") {
            e.preventDefault();
            setHighlightIndex((prev) => {
                const prevItem = prev > 0 ? prev - 1 : SuggestionBoxArray.length - 1;
                scrollToItem(suggestionBoxRef, prevItem);
                return prevItem;
            });
        } else if (e.key == "Enter" || e.key == "Tab") {
            e.preventDefault();
            const selectedItem = SuggestionBoxArray[highlightIndex] || SuggestionBoxArray[0]
            if (selectedItem?.props) {
                const utilizerid = selectedItem.props.utilizerid;
                if (utilizerid) {
                    GetUtilizerDataById(utilizerid);
                }
            }
            setShowSuggestionDevice("d-none");
        }
    }

    const resetUserFields = (CheckAssignDevice) => {
        setAllData((prev) => ({
            ...prev,
            FirstName: "",
            MiddleName: "",
            LastName: "",
            StudentNumber: "",
            ParentName: "",
            ParentEmail: "",
            ParentPhoneNumber: "",
            ParentCheck: 0,
            StudentIDD: null,
            Grade: "",
            Department: "",
            IsStudent: "",
            UserEmail: "",
            CheckAssignDevice: CheckAssignDevice
        }));
    };

    return (
        <>
            <userdetailscontent.Provider value={{ allData, setAllData }}>
                {Alerts}
                {loading ? <ShowLoder /> : <HideLoder />}
                <div>
                    <div className="GridBox mt-2 p-3">
                        <div className='greyBox'>
                            <div className='Header'>
                                {UpdateFlag == 1 ?
                                    <b className='font-16'>Add New Device</b>
                                    :
                                    <b className='font-16'>Edit Device</b>
                                }
                                <br />
                                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
                            </div>
                            <div id='AddInventoryForm' className="parent">
                                {/* device details div */}
                                <div className='row px-2 justify-content-between'>
                                    <div className='col-md-6 row align-items-center'>
                                        <div className='col-md-7 FormLabel'>Serial # <label className='redText'>*</label></div>
                                        <div className='col-md-5'>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                name="serialnumber"
                                                className="form-control"
                                                required maxLength={100}
                                                value={allData.SerialNumber}
                                                onChange={(e) =>
                                                    setAllData({
                                                        ...allData,
                                                        SerialNumber: e.target.value.replace(/\s+/g, "").toUpperCase()
                                                    })
                                                }
                                            />
                                            <span className="form-text invalid-feedback">
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className='col-md-6 row pt-2 align-items-center'>
                                        <div className='col-md-7 FormLabel'>Building</div>
                                        <div className='col-md-5'>
                                            <div className='col-12'>
                                                <select defaultValue={allData.Building} onChange={(e) => {
                                                    setAllData({ ...allData, Building: e.target.value, SelectedRooms: '' });
                                                    if (e.target.value == "0") {
                                                        setshowbuildingdiv("");
                                                        setRoomArray([]);
                                                    } else if (e.target.value == "") {
                                                        setRoomArray([]);
                                                        setshowbuildingdiv("d-none");
                                                    }
                                                    else {
                                                        setshowbuildingdiv("d-none");
                                                        EditBuildingGetData(e.target.value)
                                                    }
                                                }}>
                                                    <option value="">Select Building</option>
                                                    <option value="0">Other</option>
                                                    {Buildings?.map((item1, j) => (
                                                        <option value={item1.id} key={j} selected={allData.Building == item1.id}>
                                                            {item1.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className={`col-12 py-3 parent ${showbuildingdiv}`}>
                                                <input type="text" maxLength={100} ref={inputRef} placeholder="Enter Building" autoComplete='off' name='building' className="form-control" value={allData.Buildingname} onChange={(e) => setAllData({ ...allData, Buildingname: e.target.value?.trimStart() })} required maxLength={100} />
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {RoomArray?.length != 0 && (
                                        <div className='col-md-6 row align-items-center'>
                                            <div className='col-md-7 FormLabel'>Room</div>
                                            <div className='col-md-5'>
                                                <div className='col-12'>
                                                    <select defaultValue={allData.SelectedRooms} required onChange={(e) => {
                                                        setAllData({ ...allData, SelectedRooms: e.target.value });
                                                    }}>
                                                        <option value="">Select Room</option>
                                                        {RoomArray?.map((item1, j) => (
                                                            <option value={item1.id} key={j} selected={allData.SelectedRooms == item1.id}>
                                                                {item1.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <span className="form-text invalid-feedback">
                                                        *required
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Device Manufacturer</div>
                                        <div className='col-md-5 parent' ref={manufBoxRef}>
                                            <div className="SearchDropDown">
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Search or Select Manufacturer"
                                                    value={allData.DeviceManufacturerId === 'other' ? 'Other' : (allData.DeviceManufacturer || '')}
                                                    onChange={(e) => handleManufacturerSearch(e.target.value)}
                                                    onFocus={() => {
                                                        if (allData.DeviceManufacturerId === 'other') return;
                                                        const currentValue = allData.DeviceManufacturer || '';
                                                        const trimmed = currentValue.trim().toLowerCase();
                                                        setManufacturerSuggestions(
                                                            trimmed
                                                                ? manufacturerData.filter(m => m.id === 'other' || m.name?.toLowerCase().includes(trimmed))
                                                                : manufacturerData
                                                        );
                                                        setShowManufSuggestions(true);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Tab') setShowManufSuggestions(false);
                                                    }}
                                                />
                                                {showManufSuggestions && allData.DeviceManufacturerId !== 'other' &&
                                                    <div className="SearchDropDown-list">
                                                        {manufacturerSuggestions.map((item) => (
                                                            <div key={item.id} className="SearchDropDown-list-option" style={{ padding: "8px 15px", cursor: "pointer" }} onClick={() => handleManufacturerSelect(item)}>
                                                                {item.name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                            {allData.DeviceManufacturerId === 'other' &&
                                                <input type="text" maxLength={100} autoComplete='off' name='devicemanufacturer' className="form-control my-3" placeholder="Enter Manufacturer Name" value={allData.DeviceManufacturer}
                                                    onChange={(e) => setAllData({ ...allData, DeviceManufacturer: e.target.value })} />}
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Device Model</div>
                                        <div className='col-md-5 parent' ref={modelBoxRef}>
                                            {allData?.DeviceManufacturerId !== 'other' &&
                                                <div className="SearchDropDown">
                                                    <input
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control"
                                                        placeholder="Search or Select Model"
                                                        maxLength={100}
                                                        value={allData.DeviceModelId === 'other' ? 'Other' : (allData.DeviceModel || '')}
                                                        onChange={(e) => handleModelSearch(e.target.value)}
                                                        onFocus={() => {
                                                            if (allData.DeviceModelId === 'other') return;
                                                            setShowModelSuggestions(true);
                                                            const manufId = deviceManufacturerIdRef.current && deviceManufacturerIdRef.current !== 'other'
                                                                ? deviceManufacturerIdRef.current
                                                                : null;
                                                            const currentValue = allData.DeviceModel || '';
                                                            const hasRealModels = modelData.some(m => m.id !== 'other');
                                                            if (!hasRealModels || currentValue.trim()) {
                                                                getModelsFromManufacturer(manufId, false, currentValue.trim() || null);
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Tab') setShowModelSuggestions(false);
                                                        }}
                                                    />
                                                    {showModelSuggestions && allData.DeviceModelId !== 'other' &&
                                                        <div className="SearchDropDown-list">
                                                            {modelData.map((item) => (
                                                                <div key={item.id} className="SearchDropDown-list-option" onClick={() => handleModelSelect(item)}>
                                                                    {item.name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                            }

                                            {(allData?.DeviceModelId === 'other' || allData?.DeviceManufacturerId === 'other') &&
                                                <input type="text" maxLength={100} autoComplete='off' name='devicemodel' placeholder="Enter Model" className="form-control my-3" value={allData.DeviceModel}
                                                    onChange={(e) => setAllData({ ...allData, DeviceModel: e.target.value })} />
                                            }
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Device MPN</div>
                                        <div className='col-md-5'>
                                            <input type="text" maxLength={100} autoComplete='off' name='devicempn' className="form-control" value={allData.DeviceMPN}
                                                onChange={(e) => setAllData({ ...allData, DeviceMPN: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Asset Tag</div>
                                        <div className='col-md-5'>
                                            <input type="text" maxLength={100} autoComplete='off' name='assettag' className="form-control" value={allData.AssetTag}
                                                onChange={(e) => setAllData({ ...allData, AssetTag: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2 '>
                                        <div className='col-md-7 FormLabel'>Repair Cap</div>
                                        <div className='col-md-5'>
                                            <div className="input-group ">
                                                <span className="input-group-text">$</span>
                                                <input type="text" autoComplete="off" className="form-control" name="repaircap"
                                                    placeholder="00" value={allData.RepairCap}
                                                    onChange={(e) => {
                                                        const onlyNumbers = e.target.value.replace(/[^0-9.]/g, "");
                                                        setAllData({ ...allData, RepairCap: onlyNumbers });
                                                    }}
                                                    maxLength={10}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Device OS</div>
                                        <div className='col-md-5'>
                                            <input type="text" maxLength={100} autoComplete='off' name='deviceos' className="form-control" value={allData.DeviceOS}
                                                onChange={(e) => setAllData({ ...allData, DeviceOS: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md-12 pt-2">
                                        <div className='col-md-12 FormLabel'>Notes</div>
                                        <div className='col-md-6 pt-1'>
                                            <textarea type="text" autoComplete='off' name='deviceos' className="form-control" rows={2} value={allData.addupdateNotes}
                                                onChange={(e) => setAllData({ ...allData, addupdateNotes: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className='col-12 text-center pt-2'>
                                        <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
                                    </div>
                                </div>

                                {/* date fields */}
                                <div className='row px-2 justify-content-between'>
                                    <div className='col-md-6 row align-items-center '>
                                        <div className='col-md-7 FormLabel'>Purchase Date</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="PurchaseDate"
                                                selectedDate={allData?.PurchaseDate
                                                    ? (() => {
                                                        const [y, m, d] = allData?.PurchaseDate?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, PurchaseDate: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center '>
                                        <div className='col-md-7 FormLabel'>Expected Retirement</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="ExpectedRetirement"
                                                selectedDate={allData?.ExpectedRetirement
                                                    ? (() => {
                                                        const [y, m, d] = allData?.ExpectedRetirement?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, ExpectedRetirement: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Manufacturer Warranty Until</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="ManufacturerWarrentyUntil"
                                                selectedDate={allData?.ManufacturerWarrentyUntil
                                                    ? (() => {
                                                        const [y, m, d] = allData?.ManufacturerWarrentyUntil?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, ManufacturerWarrentyUntil: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Manufacturer ADP Until</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="ManufacturerADPUntil"
                                                selectedDate={allData?.ManufacturerADPUntil
                                                    ? (() => {
                                                        const [y, m, d] = allData?.ManufacturerADPUntil?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, ManufacturerADPUntil: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Third Party Extended Warranty Until</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="ThirdPartyWarrantyUntil"
                                                selectedDate={allData?.ThirdPartyWarrantyUntil
                                                    ? (() => {
                                                        const [y, m, d] = allData?.ThirdPartyWarrantyUntil?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, ThirdPartyWarrantyUntil: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>Third Party ADP Until</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="ThirdPartyADPUntil"
                                                selectedDate={allData?.ThirdPartyADPUntil
                                                    ? (() => {
                                                        const [y, m, d] = allData?.ThirdPartyADPUntil?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => setAllData({ ...allData, ThirdPartyADPUntil: YYYYMMDD(e) })}
                                                placeholderText="MM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6 row align-items-center pt-2'>
                                        <div className='col-md-7 FormLabel'>{primary_text} ADP Coverage Until</div>
                                        <div className='col-md-5'>
                                            <CustomReactDatePicker
                                                inputName="adpcoverageuntil"
                                                selectedDate={allData?.adpcoverageuntil
                                                    ? (() => {
                                                        const [y, m, d] = allData?.adpcoverageuntil?.split("-");
                                                        return new Date(y, m - 1, d);
                                                    })()
                                                    : null}
                                                onChangeHandler={(e) => { if (copyaccesstype != null) return setAllData({ ...allData, adpcoverageuntil: YYYYMMDD(e) }) }}
                                                placeholderText="MM-DD-YYYY"
                                                isDisabled={copyaccesstype == null}
                                            />
                                        </div>
                                    </div>
                                    {(show_policy_no_field) && ((copyaccesstype != null) || (copyaccesstype == null && allData.policyNumber)) &&
                                        <div className='col-md-6 row align-items-center pt-2'>
                                            <div className='col-md-7 FormLabel'>Policy No.</div>
                                            <div className='col-md-5'>
                                                <input
                                                    type="text"
                                                    maxLength={100}
                                                    autoComplete='off'
                                                    name='policyNumber'
                                                    className="form-control"
                                                    value={allData.policyNumber}
                                                    onChange={(e) => { if (copyaccesstype != null) return setAllData({ ...allData, policyNumber: e.target.value }) }}
                                                    disabled={copyaccesstype == null}
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className='col-12 text-center pt-2'>
                                        <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
                                    </div>
                                </div>

                                {/*Admin custom field */}
                                <div className="p-2">
                                    <div className='row px-2 justify-content-between my2'>
                                        {adminCustomFields.length != 0 && <b>Admin Custom Fields</b>}
                                        {adminCustomFields.map((field, index) => {
                                            return (
                                                <>
                                                    <div className='col-md-6 row align-items-center py-1'>
                                                        <div className='col-md-7 FormLabel'>{field.name.charAt(0).toUpperCase() + field.name.slice(1)} {field.is_required == 1 && <span className="custom-text-danger">*</span>}</div>
                                                        <div className='col-md-5'>

                                                            <CustomFields
                                                                key={field.id}
                                                                type={parseInt(field.value_type)}
                                                                value={field.value_type == 4 || field.value_type == 5 ? field?.value ? new Date(field?.value) : null : field?.value}
                                                                options={field?.customfieldstructures}
                                                                isrequired={field.is_required}
                                                                disabled={(AdminMenuAccessFlag || copyaccesstype != null) ? false : field?.is_system_locked === 1 ? true : false}
                                                                radiorequired={radiorequired}
                                                                onChange={(value) => handleAdminFieldChange(index, field.value_type == 4 ? YYYYMMDD_HHMM(value) : field.value_type == 5 ? YYYYMMDD_HHMM(value) : value)}
                                                            />
                                                            {errors[field.id] && <span className="custom-text-danger">{errors[field.id]}</span>}

                                                        </div>
                                                    </div>
                                                </>

                                            )
                                        })}
                                    </div>

                                    {adminCustomFields.length != 0 && <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />}
                                </div>
                                {/* custom field */}
                                <div className="p-2">
                                    <div className='row px-2 justify-content-between my2'>
                                        {customFields.length != 0 && <b>Custom Fields</b>}
                                        {customFields.map((field, index) => {
                                            return (
                                                <>
                                                    <div className='col-md-6 row align-items-center py-1'>
                                                        <div className='col-md-7 FormLabel'>{field.name.charAt(0).toUpperCase() + field.name.slice(1)} {field.is_required == 1 && <span className="custom-text-danger">*</span>}</div>
                                                        <div className='col-md-5'>
                                                            <CustomFields
                                                                key={field.id}
                                                                id={field.id}
                                                                type={parseInt(field.value_type)}
                                                                value={
                                                                    field.value_type == 4 || field.value_type == 5
                                                                        ? field?.value
                                                                            ? field.value_type == 4
                                                                                ? parseDateOnly(field.value)
                                                                                : new Date(field?.value)
                                                                            : null
                                                                        : field?.value
                                                                }
                                                                options={field?.customfieldstructures}
                                                                disabled={(AdminMenuAccessFlag || copyaccesstype != null) ? false : field?.is_system_locked === 1 ? true : false}
                                                                isrequired={field.is_required}
                                                                radiorequired={radiorequired}
                                                                onChange={(value) => handleFieldChange(index, field.value_type == 4 ? YYYYMMDD(value) : field.value_type == 5 ? YYYYMMDD_HHMM(value) : value)}
                                                            />
                                                            {errors[field.id] && <span className="custom-text-danger">{errors[field.id]}</span>}
                                                        </div>
                                                    </div>
                                                </>

                                            )
                                        })}
                                    </div>

                                    {customFields.length != 0 && <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />}
                                </div>


                                {/* radio button div */}
                                <div className='row p-2 justify-content-between'>
                                    <div className='col-12 row align-items-center pt-2'>
                                        <div className='col-md-5 FormLabel'>Is this device a loaner device?</div>
                                        {allData.CheckLoanerDevice == 1 ?
                                            <div className='col-md-7 d-flex' >
                                                <div className="form-check" >
                                                    <input className="form-check-input" disabled={FormShowHide.loanerdisable} type="radio" name='LoanerDevice' defaultChecked onClick={(e) => { setFormShowHide({ ...FormShowHide, AssignDeviceDiv: 'd-none' }); handelLonerChange("yes") }} />
                                                    <label className="form-check-label">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ms-5">
                                                    <input className="form-check-input" disabled={FormShowHide.loanerdisable} type="radio" name='LoanerDevice' onClick={(e) => { setFormShowHide({ ...FormShowHide, AssignDeviceDiv: '' }); handelLonerChange("no") }} />
                                                    <label className="form-check-label">
                                                        No
                                                    </label>
                                                </div>
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                            :
                                            <div className='col-md-7 d-flex' >
                                                <div className="form-check" >
                                                    <input className="form-check-input" disabled={FormShowHide.loanerdisable} type="radio" name='LoanerDevice' onClick={(e) => { setFormShowHide({ ...FormShowHide, AssignDeviceDiv: 'd-none' }); handelLonerChange("yes") }} />
                                                    <label className="form-check-label">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check ms-5">
                                                    <input className="form-check-input" disabled={FormShowHide.loanerdisable} type="radio" name='LoanerDevice' defaultChecked onClick={(e) => { setFormShowHide({ ...FormShowHide, AssignDeviceDiv: '' }); handelLonerChange("no") }} />
                                                    <label className="form-check-label">
                                                        No
                                                    </label>
                                                </div>
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        }

                                    </div>
                                    <div className={`col-12 row align-items-center pt-3 ${FormShowHide.AssignDeviceDiv}`}>
                                        <div className='col-md-5 FormLabel'>Do you want to assign this device to user?</div>
                                        <div className='col-md-7 d-flex'>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name='AssignDevice'
                                                    checked={allData.CheckAssignDevice === 1}
                                                    onChange={(e) => handelUserChange("yes")} />
                                                <label className="form-check-label">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check ms-5">
                                                <input className="form-check-input" type="radio" name='AssignDevice'
                                                    checked={allData.CheckAssignDevice === 0}
                                                    onChange={(e) => handelUserChange("no")} />
                                                <label className="form-check-label">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* user details div */}
                                <div className={`row parent ${FormShowHide.UserDiv}`}>
                                    <img src='/images/HorizontalLine.svg' className='img-fluid w-100 mt-2 px-3' />
                                    <div className='col-md-5 pt-3'>
                                        <h3>User Details</h3>
                                    </div>
                                    <div className={`col-md-7 row align-items-center text-start`}>
                                        <div className='d-flex'>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name='existingnew' checked={ExistingNew === 1} onChange={(e) => { setExisitingerror(''); handleExistingnewuser("existing") }} />
                                                <label className="form-check-label">
                                                    Existing
                                                </label>
                                            </div>
                                            <div className="form-check ms-3">
                                                <input className="form-check-input" type="radio" name='existingnew' checked={ExistingNew === 0} onChange={(e) => { setExisitingerror(''); handleExistingnewuser("new") }} />
                                                <label className="form-check-label">
                                                    New
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 mt-2 ${FormShowHide.SuggestionBoxShow}`}>
                                        <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                            <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                                            <input className="form-control" autoComplete="off" type="text" placeholder="Search User"
                                                value={SearchString}
                                                onChange={(e) => {
                                                    SearchUsers(e.target.value);
                                                    setSearchString(e.target.value);
                                                    setHighlightIndex(-1);
                                                    // setShowSuggestionDevice("")
                                                }}
                                                onKeyDown={(e) => handleUserSelect(e)}
                                            />
                                            <div className={`SuggestionBoxDiv ${ShowSuggestionDevice}`} ref={suggestionBoxRef}>
                                                {utils.innerload && (
                                                    <div className='row'>
                                                        <div className="col-12 text-center pt-2">
                                                            <img src="/images/loder.svg" style={{ width: "30px" }} />
                                                        </div>
                                                    </div>
                                                )}
                                                {SuggestionBoxArray.map((suggestion, index) => (
                                                    <div key={index} className={`suggestion-item ${index == highlightIndex ? 'selected' : ''}`}>
                                                        {suggestion}
                                                    </div>
                                                ))}
                                            </div>
                                        </form>
                                    </div>
                                    <div className={`row ps-4 ${FormShowHide.UpdateDiv}`}>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">First Name:</div>
                                            <div className="col-md-6 col-6"><b>{allData.FirstName || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">Middle Name:</div>
                                            <div className="col-md-6 col-6"><b>{allData.MiddleName || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">Last Name:</div>
                                            <div className="col-md-6 col-6"><b>{allData.LastName || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">User Number:</div>
                                            <div className="col-md-6 col-6"><b>{allData.StudentNumber || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">User Email:</div>
                                            <div className="col-md-6 col-6"><b>{allData.UserEmail || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">{manager} Email:</div>
                                            <div className="col-md-6 col-6"><b>{allData.ParentEmail ? allData.ParentEmail : <>-</>}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">{manager} Name:</div>
                                            <div className="col-md-6 col-6"><b>{allData.ParentName ? allData.ParentName : <>-</>}</b></div>
                                        </div>
                                        {show_grade_field ?
                                            <>
                                                <div className="col-md-6 row py-2">
                                                    <div className="col-md-6 col-6">Is the user a student?:</div>
                                                    <div className="col-md-6 col-6"><b>{allData.IsStudent == 1 ? 'Yes' : 'No'}</b></div>
                                                </div>
                                                <div className="col-md-6 row py-2">
                                                    <div className="col-md-6 col-6">Grade:</div>
                                                    <div className="col-md-6 col-6"><b>{allData.Grade || '-'}</b></div>
                                                </div>
                                            </>
                                            : null}
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">Department:</div>
                                            <div className="col-md-6 col-6"><b>{allData.Department || '-'}</b></div>
                                        </div>
                                        <div className="col-md-6 row py-2">
                                            <div className="col-md-6 col-6">{manager} Phone Number:</div>
                                            <div className="col-md-6 col-6"><b>{allData.ParentPhoneNumber || '-'}</b></div>
                                        </div>
                                        {!(is_enterprise || hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR)) && (
                                            <div className="col-md-6 row py-2">
                                                <div className="col-md-6 col-6">{dcc_module_text}:</div>
                                                <div className="col-md-6 col-6">
                                                    <b>{allData.ParentCheck == 1 ? "Yes" : "No"}</b>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <h6 className="redText">{Exisitingerror}</h6>
                                    <div className={`${FormShowHide.UserDetailDiv} parent`}>
                                        <UserDetails />
                                    </div>
                                </div>

                                {/* save cancel button div */}
                                <div className='col-12 text-center pt-4'>
                                    {UpdateFlag == 1 ?
                                        <button className='SaveBtn' onClick={(e) => AddUpdateDevice(1)}>Save Device</button>
                                        :
                                        <button className='SaveBtn' onClick={(e) => AddUpdateDevice(2)}>Update Device</button>
                                    }
                                    <label className="ms-2 cursor-pointer" onClick={(e) => { !copyaccesstype && AdminMenuAccessFlag ? navigate("/school-tickets") : navigate("/manage-device") }}><u>Cancel</u></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </userdetailscontent.Provider >
        </>
    )
}
